import { addRecord, addRecords } from '../helpers'
import * as types from '../mutation-types'

export default {
  state: {
    current: {
      id: 0,
      is_expiring: false,
      is_loading: true,
      is_terminating: false,
      is_visible: false,
      expired_seconds_remaining: 86400, // 24 hours
      refresh_interval: 10000
    },
    reservation_transactions: [],
    reservation_instances: [],
    reservation_saves: []
  },

  mutations: {
    [types.ADD_RESERVATION_TRANSACTION] (state, reservation_transaction) {
      addRecord(state.reservation_transactions, reservation_transaction, 'reservation_transactions')
    },
    [types.ADD_RESERVATION_TRANSACTIONS] (state, reservation_transactions) {
      addRecords(state.reservation_transactions, reservation_transactions, 'reservation_transactions')
    },
    [types.ADD_RESERVATION_INSTANCES] (state, reservation_instances) {
      addRecords(state.reservation_instances, reservation_instances, 'reservation_instances')
    },
    [types.ADD_RESERVATION_SAVES] (state, reservation_saves) {
      addRecords(state.reservation_saves, reservation_saves, 'reservation_saves')
    },
    [types.CLEAR_RESERVATION_SAVES] (state) {
      state.reservation_saves = []
    },
    [types.SET_CURRENT_RESERVATION] (state, id) {
      state.current.id = id
      state.current.is_loading = false
      state.current.is_visible = (id != 0)
    },
    [types.SET_RESERVATION_IS_EXPIRING] (state, is_expiring) {
      state.current.is_expiring = is_expiring
    },
    [types.SET_RESERVATION_IS_TERMINATING] (state, is_terminating) {
      state.current.is_terminating = is_terminating
    },
    [types.SET_RESERVATION_IS_VISIBLE] (state, is_visible) {
      state.current.is_visible = is_visible
    },
  },

  actions: {
    getCurrentReservation (context) {
      axios.get('/api/me/reservation')
        .then(function (response) {
          // success callback
          let reservation = response.data
          // Add reservation transaction
          context.commit(types.ADD_RESERVATION_TRANSACTION, reservation.data)
          // Add included relationship data
          context.commit(types.ADD_CONTENT_MODULES, reservation.included)
          context.commit(types.ADD_IMAGE_BLUEPRINTS, reservation.included)
          context.commit(types.ADD_IMAGE_FLAVORS, reservation.included)
          context.commit(types.ADD_IMAGE_SNAPSHOTS, reservation.included)
          context.commit(types.ADD_INFRASTRUCTURE_INSTANCES, reservation.included)
          context.commit(types.ADD_INFRASTRUCTURE_PODS, reservation.included)
          context.commit(types.ADD_TOPOLOGY_BLUEPRINTS, reservation.included)
          context.commit(types.ADD_TOPOLOGY_GROUPS, reservation.included)
          // Set the current reservation
          context.commit(types.SET_CURRENT_RESERVATION, reservation.data.id)
        })
        .catch(function (error) {
          // error callback
          context.commit(types.SET_CURRENT_RESERVATION, 0)
        })
    },

    patchCurrentReservation (context, payload) {
      axios.patch('/api/me/reservation')
        .then(function (response) {
          payload.self.getCurrentReservation()
        })
        .catch(function (error) {
          // error callback
        })
    },

    setIsExpiring (context, payload) {
      context.commit(types.SET_RESERVATION_IS_EXPIRING, payload.is_expiring)
    },

    setIsTerminating (context, payload) {
      context.commit(types.SET_RESERVATION_IS_TERMINATING, payload.is_terminating)
    },

    setIsVisible (context, payload) {
      context.commit(types.SET_RESERVATION_IS_VISIBLE, payload.is_visible)
    },

    powerInstance (context, payload) {
      axios.patch('/api/me/reservation/infrastructure_instances/' + payload.id)
        .then(function (response) {
          payload.self.getCurrentReservation()
        })
        .catch(function (error) {
          // error callback
        })
    },

    revertInstanceSnapshot (context, payload) {
      axios.delete('/api/me/reservation/infrastructure_instances/' + payload.id)
        .then(function (response) {
          payload.self.getCurrentReservation()
        })
        .catch(function (error) {
          // error callback
        })
    },

    getReservationSaves (context, payload) {
      axios.get('/api/me/reservation_saves')
        .then(function (response) {
          // success callback
          let snapshots = response.data
          // Add image snapshots
          context.commit(types.CLEAR_RESERVATION_SAVES)
          context.commit(types.ADD_RESERVATION_SAVES, snapshots.data)
        })
        .catch(function (error) {
          // error callback
        })
    },

    postReservationSave (context, payload) {
      let url = '/api/me/reservation_saves'

      axios.post(url, payload.json)
        .then(function (response) {
          // success callback
          window.location.href = '/saves'
        })
        .catch(function (error) {
          // error callback
          window.location.href = '/connect'
        })
    },
  }
}
